<template>
  <header class="sticky top-0 z-40 border-b border-white/40 dark:border-white/10 glass-panel">
    <div class="flex items-center justify-between gap-4 h-16 px-4 sm:px-6">
      <div class="flex items-center gap-3 min-w-0 flex-1">
        <button
          type="button"
          class="lg:hidden shrink-0 p-2 rounded-xl glass-subtle text-muted hover:text-foreground transition-colors"
          aria-label="Open menu"
          @click="$emit('toggle-mobile')"
        >
          <AppIcon name="Menu" :size="22" />
        </button>

        <div class="flex items-center gap-3 min-w-0 pl-1 sm:pl-0">
          <div class="hidden sm:block w-1 h-8 rounded-full bg-primary/80 shrink-0" aria-hidden="true" />
          <div class="min-w-0">
            <h1 class="text-base sm:text-lg font-semibold text-foreground tracking-tight truncate">
              {{ pageTitle }}
            </h1>
            <p v-if="pageDescription" class="text-xs text-muted mt-0.5 truncate">
              {{ pageDescription }}
            </p>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-1.5 sm:gap-2 shrink-0">
        <button
          type="button"
          class="p-2 rounded-xl glass-subtle text-muted hover:text-foreground transition-colors"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <AppIcon :name="isDark ? 'Sun' : 'Moon'" :size="20" />
        </button>
        <BaseButton variant="primary" size="sm" tag="router-link" :to="{ path: '/', hash: '#contact' }">
          <AppIcon name="Send" :size="16" />
          <span class="hidden sm:inline">Get in touch</span>
        </BaseButton>
      </div>
    </div>
  </header>
</template>

<script>
import AppIcon from '@/components/ui/AppIcon.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import { useTheme } from '@/composables/useTheme'

export default {
  name: 'AppTopbar',
  components: { AppIcon, BaseButton },
  props: {
    pageTitle: { type: String, default: 'Portfolio' },
    pageDescription: { type: String, default: '' },
  },
  emits: ['toggle-mobile'],
  setup() {
    const { isDark, toggleTheme } = useTheme()
    return { isDark, toggleTheme }
  },
}
</script>
